import React, { FC, RefObject, Suspense } from 'react';
import classNames from 'classnames';

import { ClosePlayerButton } from '../../../feature-player/ui/skin/close-player-button/component';
import { BaseControlName } from '../../../feature-player/types/controls';
import { SubtitlesProvider } from '../../../feature-player/ui/subtitles/subtitles-provider/components';
import { ContextMenuContainer } from '../../../feature-player/ui/skin/context-menu/container';
import { useKeyboard } from '../../hooks/useKeyboard';
import { GlobalKeyboardHandlerTogglersProvider } from '../../../feature-player/contexts/global-keyboard-handler-togglers';
import { SubtitlesPortalRoot } from '../../../feature-player/ui/subtitles/subtitles-portal-root/component';
import { SportPlayerControlPanel } from '../SportPlayerControlPanel/SportPlayerControlPanel';
import { SportPlayerMeta } from '../SportPlayerMeta/SportPlayerMeta';
import { SportLayout } from '../SportLayout/SportLayout';
import { SportPlayButton } from '../SportPlayButton/SportPlayButton';
import { useOnSportLiveEnd } from '../../hooks/useOnSportLiveEnd';

import styles from './SportPlayerSkin.module.css';

interface SportPlayerSkinProps {
    contentId: string;
    onClose: () => void;
    className?: string;
    psid: string;
    rootContainerRef: RefObject<HTMLDivElement>;
}

export const SportPlayerSkin: FC<SportPlayerSkinProps> = ({
    contentId,
    onClose,
    className,
    rootContainerRef,
    psid,
}) => {
    useKeyboard({ onClose });
    useOnSportLiveEnd(onClose);

    return (
        <SubtitlesProvider>
            <GlobalKeyboardHandlerTogglersProvider>
                <SportLayout
                    rootContainerRef={rootContainerRef}
                    className={classNames(styles.layout, className)}
                    renderTopControls={() => (
                        <ClosePlayerButton
                            name={BaseControlName.CLOSE}
                            onClick={onClose}
                            className={styles.closeButton}
                            contentId={contentId}
                        />
                    )}
                    renderBottomControls={({ setIsHidingControlsBlocked }) => (
                        <div className={styles.bottomControls}>
                            <Suspense fallback={null}>
                                <SportPlayerMeta contentId={contentId} className={styles.meta}>
                                    {({ onEnlargementChanged }) => (
                                        <SportPlayerControlPanel
                                            contentId={contentId}
                                            psid={psid}
                                            setIsHidingControlsBlocked={setIsHidingControlsBlocked}
                                            onEnlargementChanged={onEnlargementChanged}
                                        />
                                    )}
                                </SportPlayerMeta>
                            </Suspense>
                        </div>
                    )}
                    renderControls={({ isControlsVisible }) => (
                        <>
                            <SportPlayButton className={styles.playButton} />
                            <SubtitlesPortalRoot isControlsVisible={isControlsVisible} />
                        </>
                    )}
                    renderPopups={() =>
                        rootContainerRef && (
                            <ContextMenuContainer rootContainerRef={rootContainerRef} />
                        )
                    }
                />
            </GlobalKeyboardHandlerTogglersProvider>
        </SubtitlesProvider>
    );
};
